import React, { useState } from "react";
import {
  Container, Row, Col, Alert
} from "react-bootstrap";
import GoogleMapReact from "google-map-react";
import { IMapMarker } from "interfaces/components/Map/IMapConfig";
import { GoogleMapProps } from "interfaces/components/Map/GoogleMapProps";
import "./googlemap.scss";
import MapMarker from "./MapMarker";

const GoogleMap = ({
  markers,
  onMapLoad,
  googleMapOptions,
  zoom,
  layerTypes,
  center
}: GoogleMapProps) => {
  const [showNoLocationsBanner, setShowNoLocationsBanner] = useState<boolean>(true);

  const renderMarkersOnMap = (mapMarkers: IMapMarker[]) => mapMarkers.map((marker: IMapMarker, index: number) => (
    <MapMarker
      id={marker.key}
      key={marker.key !== 0 ? marker.key : index}
      lat={marker.location.latitude}
      lng={marker.location.longitude}
      title={marker.title}
      text={marker.text}
      icon={marker.icon}
      onClick={marker.onClick}
      details={marker.details}
    />
  ));

  const getGoogleMapLatLngBounds = (googleMap: any): any => {
    const bounds = new googleMap.maps.LatLngBounds();

    markers.forEach((marker: IMapMarker) => {
      bounds.extend(
        new googleMap.maps.LatLng(
          marker.location.latitude,
          marker.location.longitude
        )
      );
    });

    return bounds;
  };

  const handleGoogleApiLoaded = (googleMap: any) => {
    const mapBounds = getGoogleMapLatLngBounds(googleMap);
    onMapLoad(googleMap, mapBounds);
  };

  const checkForEmptyMarkers = (): boolean => !markers || markers.length === 0;

  return (
    <div id="google-map-container">
      {showNoLocationsBanner && checkForEmptyMarkers() ? (
        <Container>
          <Alert
            dismissible
            onClose={() => {
              setShowNoLocationsBanner(false);
            }}
            variant="info"
            className="margin-medium"
            aria-atomic="true"
          >
            No locations found.
          </Alert>
        </Container>
      ) : (
        <>
          <Row>
            <Col>
              {markers && (
                <div className="map">
                  <div className="google-map" data-testid="googleMap">
                    <GoogleMapReact
                      options={maps => googleMapOptions(maps)}
                      bootstrapURLKeys={{
                        key: process.env.REACT_APP_GOOGLE_API_KEY || ""
                      }}
                      center={{ lat: center?.latitude, lng: center?.longitude }}
                      zoom={zoom}
                      yesIWantToUseGoogleMapApiInternals
                      onGoogleApiLoaded={handleGoogleApiLoaded}
                      layerTypes={layerTypes}
                    >
                      {React.Children.toArray(renderMarkersOnMap(markers))}
                    </GoogleMapReact>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default GoogleMap;
